<div class="container my-3">
  <!-- <h1 class="mb-3 ">Add New Company</h1> -->
  <div class="row mt-4">
    <form #form="ngForm" (ngSubmit)="addCompany()">
      <!-- <?div> -->
      <div class="row">
        <div class="col-sm-1" style="text-align: center;">
          <label for="name" class="form-label">Name:</label>
        </div>
        <div class="col-sm-4">
          <input
            style="float: left"
            type="text"
            class="form-control border border-dark"
            id="name"
            name="name"
            [(ngModel)]="addCompanyRequest.Name"
            required
          />
          <div
          *ngIf="NameError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        </div>
      </div>


      <div style="min-height: 100px;"></div>
      <div class="row">
        <div class="col-sm-1" style="text-align: right">
          <button type="submit" class="btn custom-buttons-btn mt-3">Submit</button>
        </div>
        <div class="col-sm-2" style="text-align: left">
          <button type="button" class="btn custom-buttons-btn mt-3">Clear</button>
        </div>
      </div>
    </form>
  </div>
</div>
